"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceDesignRequestModel = void 0;
const core = __importStar(require("../../../../../core"));
const VoiceDesignRequestModelModelId_1 = require("../../types/VoiceDesignRequestModelModelId");
exports.VoiceDesignRequestModel = core.serialization.object({
    voiceDescription: core.serialization.property("voice_description", core.serialization.string()),
    modelId: core.serialization.property("model_id", VoiceDesignRequestModelModelId_1.VoiceDesignRequestModelModelId.optional()),
    text: core.serialization.string().optional(),
    autoGenerateText: core.serialization.property("auto_generate_text", core.serialization.boolean().optional()),
    loudness: core.serialization.number().optional(),
    seed: core.serialization.number().optional(),
    guidanceScale: core.serialization.property("guidance_scale", core.serialization.number().optional()),
    streamPreviews: core.serialization.property("stream_previews", core.serialization.boolean().optional()),
    quality: core.serialization.number().optional(),
    referenceAudioBase64: core.serialization.property("reference_audio_base64", core.serialization.string().optional()),
    promptStrength: core.serialization.property("prompt_strength", core.serialization.number().optional()),
});
